import { ADD_BRAND } from '../../endpoints';
import { IBrand } from '../../types/brand';
import makeAuthenticatedRequest from '../base-api';

interface AddBrandResponse {
  success: boolean;
  message?: string;
  brand?: IBrand;
}

const addBrandApi = async (payload: IBrand): Promise<AddBrandResponse> => {
  try {
    const response = await makeAuthenticatedRequest(ADD_BRAND, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Add brand failed:', error);
    throw error;
  }
};

export { addBrandApi, type AddBrandResponse };
